@if (hasData()) {
  <div
    echarts
    role="img"
    [attr.aria-label]="ariaLabel()"
    [options]="chartOptions()"
    [autoResize]="true"
    [style.height.px]="height()"
  ></div>
}
